import { TransportMode } from '../../../../models/transport-mode.enum';
import { TranslationService } from '../../../../services/translation.service';
import TicketSuggestions from '../../TicketSuggestions';
import type { ITicketSuggestion } from '../../../../models/ticket-suggestion.model';
import type { IJourney } from '../../../../models/journey.model';

function JourneyTicketSuggestions({ journey, ticketSuggestions }: { journey: IJourney; ticketSuggestions: ITicketSuggestion[] }) {
  const destinationLinkTransportMode = journey.destinationLink?.transportMode;

  if (destinationLinkTransportMode === undefined) {
    return <TicketSuggestions id={journey.id.toString()} ticketSuggestions={ticketSuggestions}></TicketSuggestions>;
  }

  return (
    <div className="text-center p-3">
      {destinationLinkTransportMode === TransportMode.walk && <span>{TranslationService.get('travelplanner.walkjourneypricetext')}</span>}
      {destinationLinkTransportMode === TransportMode.bike && <span>{TranslationService.get('travelplanner.bikejourneypricetext')}</span>}
    </div>
  );
}

export default JourneyTicketSuggestions;
